(function () {
  function toast(message) {
    var node = document.querySelector('.nx-toast');
    if (!node) return;
    node.textContent = message;
    node.classList.add('is-visible');
    window.clearTimeout(window.nexivoToastTimer);
    window.nexivoToastTimer = window.setTimeout(function () { node.classList.remove('is-visible'); }, 2600);
  }

  function refreshCartCount() {
    return fetch(window.NEXIVO.cartJsonUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count; });
      });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.js-product-form:not([data-nx-ready])').forEach(function (form) {
      form.setAttribute('data-nx-ready', 'true');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[type="submit"]');
        if (button) button.disabled = true;
        fetch(window.NEXIVO.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (response) { if (!response.ok) throw new Error('cart'); return response.json(); })
          .then(function () { return refreshCartCount(); })
          .then(function () { toast(window.NEXIVO.addedText); })
          .catch(function () { toast(window.NEXIVO.errorText); })
          .finally(function () { if (button) button.disabled = false; });
      });
    });

    scope.querySelectorAll('[data-variant-select]:not([data-nx-ready])').forEach(function (select) {
      select.setAttribute('data-nx-ready', 'true');
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var price = select.closest('[data-product-section]').querySelector('[data-product-price]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
      });
    });

    scope.querySelectorAll('[data-sort-select]:not([data-nx-ready])').forEach(function (select) {
      select.setAttribute('data-nx-ready', 'true');
      select.addEventListener('change', function () { select.form.submit(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('[data-header]');
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 20); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        nav.classList.toggle('is-open', !open);
        document.body.classList.toggle('menu-open', !open);
      });
      nav.querySelectorAll('a').forEach(function (link) { link.addEventListener('click', function () { toggle.setAttribute('aria-expanded', 'false'); nav.classList.remove('is-open'); document.body.classList.remove('menu-open'); }); });
    }
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
